import { useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

interface Props {
    open: boolean;
    onClose: (comment: string) => void;
}

export const AT1FeedbackNegativeModal = ({ open, onClose }: Props) => {
    const [comment, setComment] = useState('');
    const { formatMessage } = useIntl();

    const handleSubmit = () => {
        onClose(comment.trim());
        setComment('');
    };

    const handleClose = () => {
        onClose('');
        setComment('');
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ typography: 'h2' }}>
                {formatMessage({ id: 'discussion.at1_feedback.modal.title' })}
            </DialogTitle>
            <DialogContent>
                <TextField
                    multiline
                    rows={4}
                    fullWidth
                    placeholder={formatMessage({ id: 'discussion.at1_feedback.modal.placeholder' })}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    autoFocus
                />
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleSubmit}>
                    {formatMessage({ id: 'discussion.at1_feedback.modal.submit' })}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
